module.exports = __webpack_public_path__ + "static/media/onboarding_push_dialog_teaser.ceb3ef3e.png";